import React, { Component } from 'react';
import { divide } from '../../../../../../models/market-map/divider';
import Ticker from '../Tickers';
import { getColor } from '../../../../../../models/market-map/data-parser';
import './index.css';


class Industrie extends Component {

  constructor(props) {
    super(props);
    this.state = {
      hover:false,
      hoverColor:'rgb(255, 177, 41)',
      tickers:[]
    }
    this.handleMouseHover = this.handleMouseHover.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.divideTickers = this.divideTickers.bind(this);
    this.setMarketMapRatio = this.setMarketMapRatio.bind(this);
  }

  
  setMarketMapRatio(){
    this.divideTickers(this.props.industrie)
  }

  componentDidMount(){
    window.addEventListener('resize', this.setMarketMapRatio);
    this.divideTickers(this.props.industrie)
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.setMarketMapRatio)
  }
  

  UNSAFE_componentWillReceiveProps(newProps){
    if( (newProps.industrie.updatedAt !== this.props.industrie.updatedAt) || 
    (newProps.showPrice !==this.props.showPrice) ){
      this.divideTickers(newProps.industrie)
    }
    if((newProps.searchResult !==this.props.searchResult)){
      if(newProps.searchResult.industrieId === newProps.industrie.id)
        this.setState({hover:true})
    }
  }

  divideTickers(industrie){
    const { w,h } = industrie.position;
    let _w = w-4;
    let _h = h-26;
    let tickers = divide(industrie.tickers,_w,_h,0,0) //(data array, width, height, left, top);
    this.setState({tickers})  
  }

  handleMouseHover(e, ticker){
    const { industrie } = this.props;
    this.setState({hover:true})
    this.props.onMouseHover(industrie, ticker)
  }
  

  handleMouseLeave(){
    this.setState({hover:false})
    this.props.onMouseHover(null, null)
  }

  render() {
    const { industrie, showPrice } = this.props;
    const { hover, hoverColor,tickers } = this.state;
    const { w,h,t,l } = industrie.position;
    //console.log('Industrie searchResult --------- ', this.props.searchResult)
    return (
      <div id='sc-market-map-industrie-container' 
        onMouseEnter={this.handleMouseHover}
        onMouseLeave={this.handleMouseLeave}
        style={{width:w-3, height:h-4, top:t, left:l}}>
        <div className='sc-market-map-industrie-text' 
          style={{
            backgroundColor:hover ? `${hoverColor}` : getColor(industrie.color), 
            borderColor:hover ? `${hoverColor}` : ''}}>
          <div className='sc-market-map-industrie-title' style={{width:w-8}}>{industrie.title}</div>
          <div className='sc-market-map-industrie-triangle' 
            style={{backgroundColor:hover ? `${hoverColor}` : getColor(industrie.color),
              borderColor:hover ? `${hoverColor}` : '',
              display: w < 35 || h < 35 ? 'none' : ''}}>
          </div>
        </div>

        <div style={{position:'absolute',width:w, height:h-26}}>
          {tickers.map((ticker, index)=>{
            return (
              <Ticker 
                key={ticker.scale + index + ticker.title} ticker={ticker} hover={hover} showPrice={showPrice}
                hoverColor={hoverColor} onMouseHover={this.handleMouseHover}/>
            )})}
        </div>
      </div>
    );
  }
}




export default Industrie;






































// import React, { Component } from 'react';
// import { divide } from '../../../../../../models/market-map/divider';
// import Ticker from '../Tickers';
// import './index.css';


// class Industrie extends Component {

//   constructor(props) {
//     super(props);
//     this.state = {
//       hover:false,
//       hoverColor:'rgb(255, 177, 41)',
//       tickers:[]
//     }
//     this.handleMouseHover = this.handleMouseHover.bind(this);
//     this.handleMouseLeave = this.handleMouseLeave.bind(this);
//     this.divideTickers = this.divideTickers.bind(this);
//     this.renderTickers = this.renderTickers.bind(this);
//     this.mapTickers = this.mapTickers.bind(this);
//   }

//   componentDidMount(){
//     this.renderTickers(this.props.industrie)
//   }

//   componentWillReceiveProps(newProps){
//     if(newProps.industrie.updatedAt !== this.props.industrie.updatedAt){
//       this.renderTickers(newProps.industrie)
//     }
//   }

//   divideTickers(industrie){
//     const { w,h } = industrie.position;
//     let tickers = divide(industrie.tickers,w-4,h-23,0,0) //(data array, width, height, left, top);
//     return tickers;
//   }

//   mapTickers(tickers){
//     const { hover, hoverColor } = this.state;
//     let res = tickers.map((ticker, index)=>{return (<Ticker key={ticker.scale + index + ticker.title} ticker={ticker} hover={hover} 
//       hoverColor={hoverColor} onMouseHover={this.handleMouseHover}/>
//     )})
//     return res;
//   }

//   renderTickers(industrie){
//     let res = this.divideTickers(industrie);
//     let tickers = this.mapTickers(res);
//     this.setState({tickers});
//   }

//   handleMouseHover(e, ticker){
//     const { industrie } = this.props;
//     this.setState({hover:true})
//     this.renderTickers(this.props.industrie)
//     this.props.onMouseHover(industrie, ticker)
//   }

//   handleMouseLeave(){
//     this.setState({hover:false})
//     this.renderTickers(this.props.industrie)
//     this.props.onMouseHover(null, null)
//   }


//   render() {
//     const { industrie } = this.props;
//     const { hover, hoverColor, tickers } = this.state;
//     const { w,h,t,l } = industrie.position;
//     return (
//       <div id='sc-market-map-industrie-container' 
//         onMouseEnter={this.handleMouseHover}
//         onMouseLeave={this.handleMouseLeave}
//         style={{width:w-3, height:h-4, top:t, left:l}}>
//         <div className='sc-market-map-industrie-text' 
//           style={{height: h < 20 ? '10px':'',backgroundColor:hover ? `${hoverColor}` : '', borderColor:hover ? `${hoverColor}` : ''}}>
//           {w < 30 || h < 30 ? '...': industrie.title}
//         </div>
//         <div className='sc-market-map-industrie-triangle' 
//           style={{backgroundColor:hover ? `${hoverColor}` : '',borderColor:hover ? `${hoverColor}` : '', display: w < 30 || h < 30 ? 'none' : ''}}></div>
//         <div style={{position:'absolute',width:w, height:h-21}}>
//           {tickers}
//           {/* {tickers.map((ticker, index)=>{
//             return (
//               <Ticker 
//                 key={ticker.scale + index + ticker.title} ticker={ticker} hover={hover} 
//                 hoverColor={hoverColor} onMouseHover={this.handleMouseHover}/>
//             )})} */}
//         </div>
//       </div>
//     );
//   }
// }




// export default Industrie;



























